<template>
  <div ref="control-container">
    <slot />
  </div>
</template>

<script>
import L from 'leaflet'
import { getMapParent } from '@/utils/utils'

export default {
  name: 'MapControl',
  props: {
    position: {
      type: String,
      default: 'topright'
    }
  },
  data () {
    return {
      map: null,
      control: null
    }
  },
  created () {
    this.map = getMapParent(this.$parent).map

    const LControl = L.Control.extend({
      element: undefined,
      onAdd () {
        return this.element
      },
      setElement (el) {
        this.element = el
      }
    })

    this.control = new LControl({
      position: this.position
    })
  },
  async mounted () {
    L.DomEvent.disableClickPropagation(this.$refs['control-container'])

    this.control.setElement(this.$el)

    await this.$nextTick()

    this.map.addControl(this.control)

    this.$emit('ready', this.map)
  },
  destroyed () {
    this.map.removeControl(this.control)
  }
}
</script>

<style lang="scss" scoped>
.leaflet-control {
  &-button {
    a {
      width: 30px;
      height: 30px;
      line-height: 30px;
    }

    & a:last-child {
      border-bottom-left-radius: 2px;
      border-bottom-right-radius: 2px;
    }

    & a:first-child {
      border-top-left-radius: 2px;
      border-top-right-radius: 2px;
    }
  }
}
</style>
